import apiHelper from '@/utils/apiHelper';
import getRandomBetween from '@/utils/getRandomBetween';
import useUserState from '@/state/useUserState';
import useMainState from '@/state/useMainState';

const { isDemoUser } = useUserState();
const { userProperties, propertyId } = useMainState();

const opportunitiesRequestHandler = async (...args) => {
  if (isDemoUser.value) {
    if (args[1].match(/opportunities\/\d+/)) {
      return {
        data: {
          data: [
            {
              opportunityId: '20220612_1034111_disparities_1',
              propertyId: propertyId.value,
              action: 'reduce',
              metric: 'disparity frequency',
              propertyValue: 0.514,
              compsetValue: 0.296,
              valueType: 'percentage',
              impact: 'medium',
              goal: 'disparities',
              uplift: 0.379,
              lostRevenue: 47,
              strataType: 'travel_party',
              strataValue: 'couple',
              ota: 'booking',
              status: 0,
            },
            {
              opportunityId: '20220612_1034111_revenue_1',
              propertyId: propertyId.value,
              action: 'increase',
              metric: 'avg daily revenue',
              propertyValue: 129.24246895313263,
              compsetValue: 163.42445041600513,
              valueType: 'currency',
              impact: 'low',
              goal: 'revenue',
              uplift: 0.269,
              lostRevenue: 1300,
              strataType: 'total',
              strataValue: 'all',
              ota: null,
              status: 0,
            },
            {
              opportunityId: '20220612_1034111_revenue_2',
              propertyId: propertyId.value,
              action: 'increase',
              metric: 'visit to search conversion rate',
              propertyValue: 0.46,
              compsetValue: 0.49,
              valueType: 'percentage',
              impact: 'low',
              goal: 'revenue',
              uplift: 0.063,
              lostRevenue: 300,
              strataType: 'total',
              strataValue: 'all',
              ota: null,
              status: 0,
            },
          ],
          meta: {
            disparitiesTotals: {
              lostRevenue: 47,
              uplift: 0.379,
            },
          },
        },
      };
    }

    return {
      data: {
        data: {
          disparities: {
            action: 'reduce',
            lost_revenue_total: 300061,
            properties_count: userProperties.value.length,
            uplift_total: 0.8,
            properties: userProperties.value.map((property, idx) => ({
              impact: 'high',
              lostRevenue: getRandomBetween(8000, 13000),
              opportunityId: `20220612_1013937_disparities_${idx}`,
              propertyId: property.propertyId,
              status: 0,
              uplift: getRandomBetween(50, 100) / 100,
            })),
          },
          revenue: {
            action: 'increase',
            lost_revenue_total: 24117100,
            properties_count: userProperties.value.length,
            uplift_total: 0.3,
            properties: userProperties.value.map((property, idx) => ({
              impact: 'max',
              lostRevenue: getRandomBetween(650000, 900000),
              opportunityId: `20220612_1012150_revenue_${idx}`,
              propertyId: property.propertyId,
              status: 0,
              uplift: getRandomBetween(50, 100) / 100,
            })),
          },
        },
        meta: {},
      },
    };
  }

  const res = await apiHelper(...args);
  return res;
};

export default opportunitiesRequestHandler;
